import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';

const SectionLocale = () => {
  return (
    <section className="py-20 px-4 bg-slate-900">
      <div className="max-w-6xl mx-auto">
        <div className="bg-gradient-to-br from-slate-800/70 to-slate-900/70 backdrop-blur-sm p-8 md:p-12 rounded-2xl border-2 border-red-600/30 shadow-2xl">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-8 text-center">
            JC Performance-57 à <span className="text-red-600">Creutzwald</span> – Moselle
          </h2>
          
          <div className="space-y-6 text-gray-300 text-lg leading-relaxed mb-10">
            <p>
              Situé au <strong className="text-white">14 rue Saint-Malo à Creutzwald (57150)</strong>, <strong className="text-red-600">JC Performance-57</strong> accueille les particuliers et professionnels pour leurs besoins en <strong className="text-white">diagnostic, électricité automobile et gestion électronique</strong>.
            </p>
            
            <p>
              Nous intervenons également pour les clients situés dans les environs de <strong className="text-white">Saint-Avold, Freyming-Merlebach, Forbach, Boulay-Moselle et Sarreguemines</strong>, selon les prestations.
            </p>
            
            <p className="text-xl text-red-600 font-semibold">
              Vous recherchez un électricien automobile ou un spécialiste du diagnostic à Creutzwald ? Contactez JC Performance-57.
            </p>
          </div>
          
          {/* Coordonnées en highlight */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10">
            <div className="flex items-start space-x-4 bg-slate-800/50 p-6 rounded-xl border border-slate-700">
              <MapPin className="h-8 w-8 text-red-600 flex-shrink-0 mt-1" />
              <div>
                <h3 className="text-white font-bold mb-2">Adresse</h3>
                <p className="text-gray-300">14 rue Saint-Malo<br />57150 Creutzwald</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-4 bg-slate-800/50 p-6 rounded-xl border border-slate-700">
              <Phone className="h-8 w-8 text-red-600 flex-shrink-0 mt-1" />
              <div>
                <h3 className="text-white font-bold mb-2">Téléphone</h3>
                <a href="tel:0749995728" className="text-red-600 hover:text-red-500 font-semibold text-lg">
                  07 49 99 57 28
                </a>
              </div>
            </div>
            
            <div className="flex items-start space-x-4 bg-slate-800/50 p-6 rounded-xl border border-slate-700">
              <Clock className="h-8 w-8 text-red-600 flex-shrink-0 mt-1" />
              <div>
                <h3 className="text-white font-bold mb-2">Horaires</h3>
                <p className="text-gray-300">Sur rendez-vous<br />Du lundi au samedi</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionLocale;
